import type { ReactNode } from 'react';
import type { DivButtonProps } from '../Button/DivButton';
import { DivButton } from '../Button/DivButton';
import styles from './styles.module.css';

export interface MagnifyButtonProps {
  onClick: NonNullable<DivButtonProps['onClick']>;
}

export function MagnifyButton({ onClick }: MagnifyButtonProps): ReactNode {
  return (
    <div className={styles.Magnify}>
      <DivButton type="primary" icon="maximize" onClick={onClick} />
    </div>
  );
}
